import type { QuestlogDb } from '../database.ts';
import { getQuestlineOrThrow } from './get_questline_or_throw.ts';
import { queryQuestlineStats } from './query_questline_stats.ts';
import type { QuestlineDetail } from './types.ts';

/**
 * Loads a questline with computed progress counts.
 */
export function getQuestlineDetail(
	db: QuestlogDb,
	questlineId: number,
	now = Date.now(),
): QuestlineDetail {
	const questline = getQuestlineOrThrow(db, questlineId);
	const stats = queryQuestlineStats(db, now, [questlineId]).get(questlineId);

	return {
		...questline,
		totalQuests: stats?.totalQuests ?? 0,
		openQuests: stats?.openQuests ?? 0,
		inProgressQuests: stats?.inProgressQuests ?? 0,
		doneQuests: stats?.doneQuests ?? 0,
		abandonedQuests: stats?.abandonedQuests ?? 0,
		availableQuests: stats?.availableQuests ?? 0,
		overdueQuests: stats?.overdueQuests ?? 0,
	};
}
